import React from 'react';
import FootEconSec from '@economist/fabric-components/footer/footeconsec/FootEconSec';
import '../../styles/normalize.css';
import '../../fonts/fonts.css';
import { withPrefix } from 'gatsby';
import UtilWebVitals from '@economist/fabric-components/utility/utilwebvitals/UtilWebVitals';
import ScrollDepth from '@economist/fabric-components/utility/ScrollDepthTracker/ScrollDepth';
import HeadAdv from '@economist/fabric-components/header/headadv/HeadAdv';
import { Helmet } from 'react-helmet';
import { Seo } from '../Seo';
import { PreloadStatic } from '../PreloadStatic';
import { MainNavigation } from '../MainNavigation';
import { MobileMenu } from '../MobileMenu';
import { HeadAdvLogo } from '../HeadAdvLogo';
import styles from './Layout.styles';

/**
 * @param children - used as content for layout
 * @param title - used as property for Seo component
 * @param description - used as property for Seo component
 * @param image - used as property for Seo component
 * @returns {JSX.Element}
 * @constructor
 */

const Layout = ({
  props: { title, description, image },
  supported = true,
  children,
  logo,
  navigation,
  locationPathName,
  imagesCommon,
  className = 'default',
}) => (
  <>
    <Helmet>
      <script src="//cmp-cdn.p.aws.economist.com/latest/configs/impact.config.js"></script>
      <script src="//cmp-cdn.p.aws.economist.com/latest/cmp.min.js"></script>
    </Helmet>
    <UtilWebVitals />
    <ScrollDepth />
    <Seo title={title} description={description} image={image} />
    <PreloadStatic />
    <div css={styles}>
      <div className="layout-header-wrapper">
        <MobileMenu articles={navigation} locationPathName={locationPathName} />
        {imagesCommon && (
          <a href={imagesCommon.logoHref} target="_blank" className="logo-href">
            <img src={withPrefix(imagesCommon.logo)} alt="logo" className="logo" />
          </a>
        )}
        <div className="navigation">
          <MainNavigation articles={navigation} locationPathName={locationPathName} />
        </div>
      </div>
      {!supported && (
        <div className="head-adv-wrapper">
          <HeadAdv sponsors={[{ sponsorLogo: withPrefix(logo) }]} />
        </div>
      )}
      <main className={className}>{children}</main>
      {supported && <HeadAdvLogo logo={logo} sign={'Supported by'} />}
      <FootEconSec />
    </div>
  </>
);

export default Layout;
